// extracted by mini-css-extract-plugin
export var root = "XXy3";
export var rootHeading = "_5vpF";
export var rootMain = "dw3d";